var exports = {
  "O": "xfd349460--033653--offers",
};

module.exports = exports;
